import { AsyncDropdown } from 'taboola-ultimate-ui';
import withDropdownField from '../../../../../taboola-common-frontend-modules/validations/components/hoc/withDropdownField';

export default withDropdownField(AsyncDropdown, true);
